

<div id="adsfsdfsdfsdsdf">
   <header id="banner" role="banner">
      <nav class="site-breadcrumbs" id="breadcrumbs">
         <ul class="breadcrumbs breadcrumbs-horizontal lfr-component">
            <li class="first"><span><a routerLink="">SIRA</a></span></li>
            <li class="last"><span><a href="/sirang/mappa-portale">MAPPA PORTALE</a></span></li>
         </ul>
      </nav>
   </header>
   <div id="content">
      <div class="portlet-boundary portlet-boundary_103_ portlet-static portlet-static-end " id="p_p_id_103_">
         <span id="p_103"></span> 
         <div class="portlet-body"> </div>
      </div>
      <div class="columns-2" id="main-content" role="main">
         <div class="portlet-layout">
            <div class="aui-w70 portlet-column portlet-column-first" id="column-1">
               <div class="portlet-dropzone portlet-column-content portlet-column-content-first" id="layout-column_column-1">
                  <div class="portlet-boundary portlet-boundary_85_ portlet-site-map  portlet-draggable" id="p_p_id_85_INSTANCE_fQgJdlHXW88l_">
                     <span id="p_85_INSTANCE_fQgJdlHXW88l"></span> 
                     <div class="portlet-body">
                        <section class="portlet" id="portlet_85_INSTANCE_fQgJdlHXW88l">
                           <table style="width: 100%;">
                              <tbody>
                                 <tr>
                                    <td>
                                       <header class="portlet-topper gradient">
                                          <h1 class="portlet-title"> <span class="portlet-title-text portlet-title-editable" style="margin-left: 0px;">Mappa del Sito</span> </h1>
                                       </header>
                                    </td>
                                 </tr>
                              </tbody>
                           </table>
                           <div class="portlet-content">
                              <div class=" portlet-content-container" style="">
                                 <div class="portlet-body">
                                    <ul>
                                       <li *ngFor="let menuitem of areetematiche">
                                          <mat-icon class="icon">{{menuitem.icon}}</mat-icon>
                                          <a *ngIf="menuitem.href != null" [href]="menuitem.href" [target]="menuitem.behavior" class="inlineblock" [title]="menuitem.title">{{menuitem.label}}</a>
                                          <a *ngIf="menuitem.route != null" [routerLink]="'/'+menuitem.route" class="inlineblock" [title]="menuitem.title">{{menuitem.label}}</a>
                                          <a *ngIf="menuitem.route == null && menuitem.href == null" [routerLink]="" class="inlineblock" [title]="menuitem.title">{{menuitem.label}}</a>
                                          <div class="divSub" *ngIf="menuitem.children.length">
                                             <div *ngFor="let menusubitem of menuitem.children">
                                                <ul>
                                                   <li *ngIf="!menusubitem.children.length">
                                                      <mat-icon class="lefticon">{{menusubitem.icon}}</mat-icon>
                                                      <a *ngIf="menusubitem.href != null" [href]="menusubitem.href" [target]="menusubitem.behavior" class="inlineblock" [title]="menusubitem.title">{{menusubitem.label}}</a>
                                                      <a *ngIf="menusubitem.route != null" [routerLink]="'/'+menusubitem.route" class="inlineblock" [title]="menusubitem.title">{{menusubitem.label}}</a>

                                                      <mat-icon class="righticon">{{menusubitem.icon2}}</mat-icon>
                                                      <a *ngIf="menusubitem.route2 != null" routerLink="viewcomp" [state]="{ url: menusubitem.route2 }" class="inlineblock" [title]="menusubitem.title2">{{menusubitem.label2}}</a>
                                                      <a *ngIf="menusubitem.href2 != null" [href]="menusubitem.href2" [target]="menusubitem.behavior2" class="inlineblock" [title]="menusubitem.title2">{{menusubitem.label2}}</a>
                                                   </li>
                                                   <li *ngFor="let menusubsubitem of menusubitem.children">
                                                      <div style="display: inline-block">
                                                         <mat-icon class="lefticon">{{menusubsubitem.icon}}</mat-icon>
                                                         <a *ngIf="menusubsubitem.href != null" [href]="menusubsubitem.href" [target]="menusubsubitem.behavior" class="inlineblock" [title]="menusubsubitem.title2">{{menusubsubitem.label}}</a>
                                                         <a *ngIf="menusubsubitem.route != null" [routerLink]="'/'+menusubsubitem.route" class="inlineblock" [title]="menusubsubitem.title2">{{menusubsubitem.label}}</a>
                                                      </div>
                                                      <div style="display: inline-block">
                                                         <mat-icon class="righticon">{{menusubsubitem.icon2}}</mat-icon>
                                                         <a *ngIf="menusubsubitem.route2 != null" routerLink="viewcomp" [state]="{ url: menusubsubitem.route2 }" class="inlineblock" [title]="menusubsubitem.title2">{{menusubsubitem.label2}}</a>
                                                         <a *ngIf="menusubsubitem.href2 != null" [href]="menusubsubitem.href2" [target]="menusubsubitem.behavior2" class="inlineblock" [title]="menusubsubitem.title2">{{menusubsubitem.label2}}</a>
                                                      </div>
                                                   </li>
                                                </ul>
                                             </div>
                                          </div>
                                       </li>
                                    </ul>
                                 </div>
                              </div>
                           </div>
                        </section>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </div>
</div>